// language=GraphQL
export const ALL_BUTTON_BLOCKS_QUERY = `query Query($withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
  buttonBlocks: cmsButtonBlocks {
    id
    variant
    size
    position
    link @include(if: $withLink) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withLinkPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withLinkPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
          id
          type
        }
      }
      travel @include(if: $withLinkTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withLinkTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withLinkTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withLinkTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withLinkTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withLinkTravelHighlights) {
          id
          text
        }
        partners @include(if: $withLinkTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withLinkTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withLinkTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withLinkTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withLinkTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withLinkTravelTestimonials) {
          id
        }
        mainImage @include(if: $withLinkTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withLinkTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withLinkTravelGallery) {
          id
        }
        travelPdf @include(if: $withLinkTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withLinkTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withLinkTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withLinkTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withLinkTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_BUTTON_BLOCK_QUERY = `query Query($id: ID!, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
  buttonBlock: cmsButtonBlock(id: $id) {
    id
    variant
    size
    position
    link @include(if: $withLink) {
      id
      label
      targetBlank
      type
      url
      page @include(if: $withLinkPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withLinkPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
          id
          type
        }
      }
      travel @include(if: $withLinkTravel) {
        id
        name
        isBestseller
        startDate
        endDate
        availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
          id
          label
          status
          isDefaultStatus
          isDefaultWaitlistFallback
        }
        executionStatus
        travelConsultant @include(if: $withLinkTravelTravelConsultant) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          phone
        }
        label @include(if: $withLinkTravelLabel) {
          id
          label
        }
        title
        description
        introVideoUrl
        includedServices
        excludedServices
        pricingTable
        priceCalculationInfo
        seoSettings @include(if: $withLinkTravelSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        tenantSettings @include(if: $withLinkTravelTenantSettings) {
          id
          onlineStatus
          redirectToBooking
          useTiming
          startDate
          endDate
        }
        highlights @include(if: $withLinkTravelHighlights) {
          id
          text
        }
        partners @include(if: $withLinkTravelPartners) {
          id
          name
          url
          logoWidth
        }
        travelGuides @include(if: $withLinkTravelTravelGuides) {
          id
          firstName
          lastName
          description
        }
        teams @include(if: $withLinkTravelTeams) {
          id
          name
        }
        accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
          id
          useCustomRoomTypeSelection
          displayDetails
        }
        accommodations @include(if: $withLinkTravelAccommodations) {
          id
          label
          name
          stars
          description
        }
        destinations @include(if: $withLinkTravelDestinations) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        testimonials @include(if: $withLinkTravelTestimonials) {
          id
        }
        mainImage @include(if: $withLinkTravelMainImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        mainVideo @include(if: $withLinkTravelMainVideo) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        gallery @include(if: $withLinkTravelGallery) {
          id
        }
        travelPdf @include(if: $withLinkTravelTravelPdf) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        travelExtensions @include(if: $withLinkTravelTravelExtensions) {
          id
          duration
          name
          description
        }
        programType
        itinerary @include(if: $withLinkTravelItinerary) {
          id
        }
        programText
        pricing @include(if: $withLinkTravelPricing) {
          id
          isTravelDocumentationAvailable
        }
        minPrice
        minPriceManualOverride
        currency
        faqs @include(if: $withLinkTravelFaqs) {
          id
          question
          answer
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_BUTTON_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsButtonBlockInput, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
    buttonBlock: createCmsButtonBlock(input: $input) {
      id
      variant
      size
      position
      link @include(if: $withLink) {
        id
        label
        targetBlank
        type
        url
        page @include(if: $withLinkPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withLinkPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
            id
            type
          }
        }
        travel @include(if: $withLinkTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withLinkTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withLinkTravelLabel) {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withLinkTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withLinkTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withLinkTravelHighlights) {
            id
            text
          }
          partners @include(if: $withLinkTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withLinkTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withLinkTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations @include(if: $withLinkTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withLinkTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withLinkTravelTestimonials) {
            id
          }
          mainImage @include(if: $withLinkTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withLinkTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withLinkTravelGallery) {
            id
          }
          travelPdf @include(if: $withLinkTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withLinkTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withLinkTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withLinkTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs @include(if: $withLinkTravelFaqs) {
            id
            question
            answer
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_BUTTON_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsButtonBlockInput, $withLink: Boolean = false, $withLinkPage: Boolean = false, $withLinkPageSeoSettings: Boolean = false, $withLinkPageContentBlockAssignments: Boolean = false, $withLinkTravel: Boolean = false, $withLinkTravelAvailabilityStatus: Boolean = false, $withLinkTravelTravelConsultant: Boolean = false, $withLinkTravelLabel: Boolean = false, $withLinkTravelSeoSettings: Boolean = false, $withLinkTravelTenantSettings: Boolean = false, $withLinkTravelHighlights: Boolean = false, $withLinkTravelPartners: Boolean = false, $withLinkTravelTravelGuides: Boolean = false, $withLinkTravelTeams: Boolean = false, $withLinkTravelAccommodationAssignments: Boolean = false, $withLinkTravelAccommodations: Boolean = false, $withLinkTravelDestinations: Boolean = false, $withLinkTravelTestimonials: Boolean = false, $withLinkTravelMainImage: Boolean = false, $withLinkTravelMainVideo: Boolean = false, $withLinkTravelGallery: Boolean = false, $withLinkTravelTravelPdf: Boolean = false, $withLinkTravelTravelExtensions: Boolean = false, $withLinkTravelItinerary: Boolean = false, $withLinkTravelPricing: Boolean = false, $withLinkTravelFaqs: Boolean = false) {
    buttonBlock: updateCmsButtonBlock(input: $input) {
      id
      variant
      size
      position
      link @include(if: $withLink) {
        id
        label
        targetBlank
        type
        url
        page @include(if: $withLinkPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withLinkPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withLinkPageContentBlockAssignments) {
            id
            type
          }
        }
        travel @include(if: $withLinkTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus @include(if: $withLinkTravelAvailabilityStatus) {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant @include(if: $withLinkTravelTravelConsultant) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label @include(if: $withLinkTravelLabel) {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings @include(if: $withLinkTravelSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings @include(if: $withLinkTravelTenantSettings) {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights @include(if: $withLinkTravelHighlights) {
            id
            text
          }
          partners @include(if: $withLinkTravelPartners) {
            id
            name
            url
            logoWidth
          }
          travelGuides @include(if: $withLinkTravelTravelGuides) {
            id
            firstName
            lastName
            description
          }
          teams @include(if: $withLinkTravelTeams) {
            id
            name
          }
          accommodationAssignments @include(if: $withLinkTravelAccommodationAssignments) {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations @include(if: $withLinkTravelAccommodations) {
            id
            label
            name
            stars
            description
          }
          destinations @include(if: $withLinkTravelDestinations) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials @include(if: $withLinkTravelTestimonials) {
            id
          }
          mainImage @include(if: $withLinkTravelMainImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo @include(if: $withLinkTravelMainVideo) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery @include(if: $withLinkTravelGallery) {
            id
          }
          travelPdf @include(if: $withLinkTravelTravelPdf) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions @include(if: $withLinkTravelTravelExtensions) {
            id
            duration
            name
            description
          }
          programType
          itinerary @include(if: $withLinkTravelItinerary) {
            id
          }
          programText
          pricing @include(if: $withLinkTravelPricing) {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs @include(if: $withLinkTravelFaqs) {
            id
            question
            answer
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_BUTTON_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsButtonBlockInput) {
    deleteCmsButtonBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_BUTTON_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsButtonBlockInput) {
    forceDeleteCmsButtonBlock(input: $input) {
      success
    }
  }`
